// service-config-lint-disable: runtime-enriched-config-export-flow-covered -- this service is intentionally enriched at runtime, and the export flow already handles it as well.
import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { FeatureExportsSymbol } from '@wix/thunderbolt-symbols'
import type { ISiteScrollBlockerDefinition } from '@wix/viewer-service-site-scroll-blocker/definition'
import { SiteScrollBlockerDefinition as definition } from '@wix/viewer-service-site-scroll-blocker/definition'
import { SiteScrollBlockerService as impl } from '@wix/viewer-service-site-scroll-blocker/implementations'
import type { IFeatureExportsStore } from 'thunderbolt-feature-exports'
import { name } from 'feature-site-scroll-blocker'

const shouldBlockScrollWithoutVar = process.env.PACKAGE_NAME !== 'thunderbolt-ds'

export const SiteScrollBlockerService: FactoryWithDependencies<
	ServiceProvider<ISiteScrollBlockerDefinition, typeof impl>
> = withDependencies(
	[named(FeatureExportsSymbol, name)],
	(
		siteScrollBlockerExports: IFeatureExportsStore<typeof name>
	): ServiceProvider<ISiteScrollBlockerDefinition, typeof impl> => {
		const config = {
			onSiteScrollBlockChanged: (status: boolean) => {
				siteScrollBlockerExports.export({
					isScrollingBlocked: status,
				})
			},
			shouldBlockScrollWithoutVar,
		}

		return {
			definition,
			impl,
			config,
		}
	}
)
